import * as React from 'react';
import DirectionContext from './direction_context';
export default function useDirection() {
  var {
    isRTL = false,
    locale = 'en-US'
  } = React.useContext(DirectionContext);
  return {
    isRTL,
    locale
  };
}